const logger = require('../utils/logger');
const fetcher = require('../utils/fetcher');
const stateSubscriber = require('./stateSubscriber');
const frontendTrackingAgent = require('../track_events/track.frontendevents.utils');
require('../utils/tag_management.utils');

Odigeo.SessionScope.logger = logger;
Odigeo.SessionScope.fetcher = fetcher;
Odigeo.SessionScope.stateSubscriber = stateSubscriber;

Odigeo.on('jsLogger:disable', logger.disableLoggers);

Odigeo.on('analytics:tracking', function(event) {
    Odigeo.requireWidget('google-analytics', 'googleanalytics', function(widget) {
        widget.execute(event.type, event.data);
    });
});

Odigeo.on('analytics:trackClick', function(event) {
    frontendTrackingAgent.trackClick(event).catch((error) => {
        console.warn(error);
    });
});

Odigeo.on('analytics:trackComponent', function(event) {
    frontendTrackingAgent.trackComponentDisplayed(event).catch((error) => {
        console.warn(error);
    });
});
